import { type FC } from 'react'
import { useWealthboxCalendarSync } from './hooks'
import { toWealthboxAttendeeSource } from './models'
import { CalendarSyncSettingsView } from '../CalendarSyncSettingsView'
import { type CalendarAttendeeSourceOption } from '../CalendarAttendeeSourceField'
import { IntegrationServiceId } from '../../../../../common/integrations'

const ATTENDEE_SOURCE_OPTIONS: CalendarAttendeeSourceOption[] = [
  { value: 'invitees', label: 'Invite (default)', description: 'Add the contacts invited to the Wealthbox event.' },
  { value: 'linked_to', label: 'Related To', description: 'Add the contacts linked in Related To. Advisors invited to the event are still added.' },
  { value: 'both', label: 'Invite and Related To', description: 'Add contacts from both fields. Each contact is only added once.' },
]

const ATTENDEE_SOURCE_NOTE =
  'Changes apply to meetings in the next 14 days. Past meetings keep their attendees. From Related To, Zocks adds contacts only, not households or projects. Contacts need an email address in Wealthbox to be matched.'

export const WealthboxCalendarSyncSettings: FC = () => {
  const { checkpoint, attendeeSource, isGetCheckpointFetching, isGetMeFetching, isSaving, save } = useWealthboxCalendarSync()

  return (
    <CalendarSyncSettingsView
      serviceId={IntegrationServiceId.WEALTHBOX}
      enabled={checkpoint?.data?.active ?? null}
      isLoading={(isGetCheckpointFetching && checkpoint === undefined) || isGetMeFetching}
      isSaving={isSaving}
      attendeeSource={attendeeSource ? { value: attendeeSource, options: ATTENDEE_SOURCE_OPTIONS, note: ATTENDEE_SOURCE_NOTE } : undefined}
      onSave={(enabled, nextAttendeeSource) => save(enabled, attendeeSource && nextAttendeeSource ? toWealthboxAttendeeSource(nextAttendeeSource) : undefined)}
      noticeVariant='warning'
      notice='Recurring meetings from Wealthbox cannot be synced due to API limitations. Individual meeting instances will still sync normally.'
    />
  )
}
